import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { MenuItem } from '@mui/material';

import { fetchUsersByNameAndLocationIds, fetchTypeaheadUsers, clearTypeahed } from '../../../actions';
import Typeahead from './Typeahead';
import TypeaheadSuggestion from './TypeaheadSuggestion';

function getSuggestionValue(suggestion) {
    return String(suggestion.userName);
}

function renderSuggestion(suggestion, { query }) {
    return (
        <MenuItem component="div">
            <TypeaheadSuggestion
                value={suggestion.userName}
                query={query}
            />
        </MenuItem>
    );
}

class UsersTypeahead extends Component {
    static propTypes = {
        labelId: PropTypes.string,
        fetchTypeaheadUsers: PropTypes.func,
        fetchUsersByNameAndLocationIds: PropTypes.func.isRequired,
        clearTypeahed: PropTypes.func.isRequired,
        suggestions: PropTypes.array,
        error: PropTypes.string,
        onChangeSuggestion: PropTypes.func,
        value: PropTypes.string,
        locationId: PropTypes.number,
        renderSuggestion: PropTypes.func,
        getSuggestionValue: PropTypes.func,
        enableSearchInactiveUsers: PropTypes.bool,
        onDisableButtons: PropTypes.func
    };

    static defaultProps = {
        labelId: 'assignTo',
        suggestions: [],
        renderSuggestion,
        getSuggestionValue
    };

    constructor(props) {
        super(props);

        const { locationId } = this.props;

        if (locationId) {
            this.locationQuery = `&locationIds=${locationId}`;
            this.fetchUsers = this.props.fetchUsersByNameAndLocationIds;
        } else {
            this.fetchUsers = this.props.fetchTypeaheadUsers;
        }
    }

    handleSuggestionsFetchRequested = term => {
        this.fetchUsers(UsersTypeahead.name, {
            term,
            enableSearchInactiveUsers: this.props.enableSearchInactiveUsers,
            enableSearchAllUsers: this.props.enableSearchAllUsers,
            locationsQuery: this.locationQuery
        });
    };

    render() {
        const { disabled, t } = this.props;
        return (
            <Typeahead
                disabled={disabled}
                error={this.props.error}
                handleSuggestionsClearRequested={this.props.clearTypeahed}
                handleSuggestionsFetchRequested={this.handleSuggestionsFetchRequested}
                onChangeSuggestion={this.props.onChangeSuggestion}
                t={t}
                {...this.props}
            />
        );
    }
}

const mapStateToProps = ({ typeahead }) => ({
    suggestions: typeahead.source === UsersTypeahead.name ?
        typeahead.list.users : UsersTypeahead.defaultProps.suggestions
});

export default connect(mapStateToProps, {
    fetchUsersByNameAndLocationIds,
    fetchTypeaheadUsers,
    clearTypeahed
})(UsersTypeahead);
